/* ==========================================================================
   MM Appointment Grid - Tipo hydration (duration + location)
   ========================================================================== */

(function () {
	"use strict";

	const DURATION_UNITS = {
		minutes: { short: "min" },
		hours: { short: "h" },
	};

	function formatDuration(duration) {
		if (!duration || typeof duration.rule === "undefined") return "";
		if (duration.all_day) return "Journée";
		const rule = Number(duration.rule);
		const unit = DURATION_UNITS[duration.unit]?.short || duration.unit;
		if (duration.unit === "minutes" && rule >= 60 && rule % 60 === 0) {
			return `${rule / 60}h`;
		}
		return `${rule} ${unit}`;
	}

	function hydrateCard(card, product) {
		if (!product) return;
		const durationEl = card.querySelector('[data-meta="duration"]');
		const durationVal = card.querySelector('[data-meta-value="duration"]');
		if (durationEl && durationVal && !durationVal.textContent.trim()) {
			const formatted = formatDuration(product.duration);
			if (formatted) {
				durationVal.textContent = formatted;
				durationEl.hidden = false;
			}
		}
		const locationEl = card.querySelector('[data-meta="location"]');
		const locationVal = card.querySelector('[data-meta-value="location"]');
		if (locationEl && locationVal && !locationVal.textContent.trim()) {
			if (product.location) {
				locationVal.textContent = product.location;
				locationEl.hidden = false;
			}
		}
	}

	function hydrateAllCards() {
		if (typeof Tipo === "undefined" || !Tipo.Booking?.configs?.products) return false;
		const products = Tipo.Booking.configs.products;
		const productMap = new Map(products.map((p) => [String(p.id), p]));
		document.querySelectorAll(".mm-appointment-card[data-service-id]").forEach((card) => {
			const id = card.dataset.serviceId;
			hydrateCard(card, productMap.get(String(id)));
		});
		return true;
	}

	function waitForTipo() {
		if (hydrateAllCards()) return;
		let attempts = 0;
		const maxAttempts = 50;
		const interval = setInterval(() => {
			attempts += 1;
			if (hydrateAllCards() || attempts >= maxAttempts) {
				clearInterval(interval);
			}
		}, 200);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", waitForTipo);
	} else {
		waitForTipo();
	}
})();
